import {DisplayEvent} from "../../../infrastructure/models/analytics/display-event";
import {APP} from "../../../core/app/consts";
import {ANALYTICS} from "../../../third-party-services/analytics/analytics-consts";

export class StandingsWidgetDisplayEvent extends DisplayEvent {
  entityId: String;
  entityType: APP.ANALYTICS.ENTITY_DISPLAY_TYPES;
  standingsTab: String;
  sportTypeId: Number;
  isStandingsPage: Number;

  constructor(params) {
    super('standings');

    this.entityType = params.entityType;
    this.entityId = params.entityId;
    this.sportTypeId = params.sportTypeId;
    this.standingsTab = 'all';
    this.isStandingsPage = params.isStandingsPage;
  }

  populate(event: StandingsWidgetDisplayEvent) {
    event.entityId && (this.entityId = event.entityId);
  }

  get properties() {
    const properties = super.properties;

    properties.entityId = this.entityId;
    properties.entityType = this.entityType;
    properties.sportTypeId = this.sportTypeId;
    properties.standingsTab = this.standingsTab;
    properties.isStandingsPage = ANALYTICS.IS_STANDINGS_PAGE[this.isStandingsPage];

    return properties;
  }
}